<template>
  <div class="header-bar">
    <el-row class="header-bar__container">
      <el-col :span="10">
        {{ TLang("欢迎来到东方福利网", "home") }}
        <template v-if="loginInfo.loginFlag">
          <a
            :href="accountURL"
            class="header-bar__item header-bar__item_first"
            >{{ loginInfo.loginUserMobile }}</a
          >
          <a class="header-bar__item" @click="onLogout">{{
            TLang("退出登录", "home")
          }}</a>
        </template>
        <template v-else>
          <a :href="loginURL" class="header-bar__item header-bar__item_first">{{
            TLang("登录", "home")
          }}</a>
          <a :href="registerURL" class="header-bar__item">{{
            TLang("注册", "home")
          }}</a>
        </template>
      </el-col>
      <el-col :span="14" class="tr">
        <a :href="mallURL" class="header-bar__item header-bar__item_first">{{
          TLang("商城首页", "home")
        }}</a>
        <a :href="accountURL" class="header-bar__item">{{
          TLang("我的账户", "home")
        }}</a>
        <a :href="cartURL" class="header-bar__item">
          <img src="./imgs/cart.png" class="header-bar__cart" alt="购物车" />{{
            TLang("购物车", "home")
          }}
        </a>
        <a :href="guideURL" class="header-bar__item">{{
          TLang("卡劵使用指南", "home")
        }}</a>
        <a class="header-bar__item header-bar__service"
          >{{ TLang("服务热线", "home") }}{{ tel }}</a
        >
        <a href="javascript:;" class="header-bar__item header-bar__wx">
          {{ TLang("微信版", "home") }}
          <img
            src="./imgs/qrcode.jpg"
            class="header-bar__qr"
            alt="东福微信公众号"
          />
          <span class="header-bar__popover">
            <img src="./imgs/qrcode.jpg" alt />
          </span>
        </a>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { removeCookie, cookieKeys, unionFlag } from "./../../utils";
export default {
  data() {
    return {
      loginInfo: {},
      tel: unionFlag() ? "400-618-2999" : "400-003-1010",
    };
  },
  computed: {
    mallURL() {
      // 商城首页
      return `/mall?cty=${this.loginInfo.city}`;
    },
    loginURL() {
      // 登录链接
      return `${this.loginInfo.loginUrl}&returnUrl=${encodeURIComponent(
        window.df_sdk_common.location.href
      )}`;
    },
    registerURL() {
      // 注册链接
      return `/user/register?city=${this.loginInfo.city}`;
    },
    accountURL() {
      // 我的账户链接
      return `/user/center?city=${this.loginInfo.city}`;
    },
    cartURL() {
      // 购物车链接
      return `/shopping/cart?city=${this.loginInfo.city}`;
    },
    guideURL() {
      // 卡券使用指南链接
      return `/static/guide?city=${this.loginInfo.city}`;
    },
  },
  created() {
    // 获取登录信息
    this.getLoginStatus();
  },
  methods: {
    getLoginStatus() {
      this.apis.headerApi.getLoginStatus().then((res) => {
        this.loginInfo = res;
      });
    },
    onLogout() {
      let cookies = cookieKeys();
      let { hostname } = window.location;
      cookies.forEach((item) =>
        removeCookie(item, "/", `${hostname.substr(hostname.indexOf("."))}`)
      );
      cookies = cookieKeys();
      cookies.forEach((item) => removeCookie(item, "/", `.${hostname}`));
      window.df_sdk_common.location.href = this.loginInfo.logoutUrl;
    },
  },
};
</script>

<style lang="less" scoped>
.header-bar {
  position: relative;
  background-color: #fafafa;
  color: #828282;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  min-width: 1200px;
  z-index: 999;
  &__container {
    .wrapper();
  }
  &__item {
    color: #828282;
    cursor: pointer;
    &:before {
      content: "|";
      position: relative;
      top: -1px;
      color: #828282;
      opacity: 0.3;
      margin-left: 15px;
      margin-right: 15px;
    }
    &:hover {
      color: #619ee0;
    }
    &_first:before {
      display: none;
    }
  }
  &__service {
    cursor: default;
    &:hover {
      color: #828282;
    }
  }
  &__cart {
    position: relative;
    top: -2px;
    vertical-align: middle;
    width: 16px;
    margin-right: 2px;
  }
  &__wx {
    display: inline-block;
    color: rgb(0, 0, 225);
    &:hover {
      .header-bar__popover {
        display: block;
      }
    }
  }
  &__qr {
    position: relative;
    top: -2px;
    vertical-align: middle;
    width: 20px;
  }
  &__popover {
    position: absolute;
    display: none;
    top: 40px;
    right: 0;
    z-index: 9;
    width: 130px;
    background-color: #fff;
    box-shadow: 0 2px 6px #dcd7d7;
    &:before {
      content: "";
      position: absolute;
      display: block;
      top: -14px;
      left: 50%;
      margin-left: -7px;
      width: 0;
      height: 0;
      line-height: 0;
      font-size: 0;
      border-width: 7px;
      border-style: solid;
      border-color: transparent transparent #fff;
    }
  }
}
</style>
